module.exports = __webpack_public_path__ + "img/FR24833.9a494674.png";